import { createClient } from '@api/client';

import { errorInterceptor } from './errors';

export const authClient = createClient({
  baseURL: process.env.NEXT_PUBLIC_AUTH_URL,
});

// specific error handling
authClient.useErrorInterceptor(errorInterceptor);

export const instance = async <T = unknown>(
  url: string,
  options?: RequestInit,
): Promise<T> => {
  return (await authClient.request<T>({
    url,
    ...options,
  })) as T;
};
